module.exports = __webpack_public_path__ + "img/Nemean.a5d7260e.png";